// @flow
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";

function BackdropLoading() {
  return (
    <CircularProgress
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        marginLeft: '-20px',
        marginRight: '-20px',
      }}
    />
  );
}

export default BackdropLoading;
